var HIDDEN_SPAN_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_SPAN_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_SPAN_STYLE[key], 'important');
  });
};
export var createHiddenNode = function createHiddenNode(inputRef) {
  var _node$parentNode;
  var node = inputRef.current;
  var hiddenSpan = document.createElement('span');
  hiddenSpan.setAttribute('tabindex', '-1');
  hiddenSpan.setAttribute('aria-hidden', 'true');
  hiddenSpan.className = 'input__mock';
  node === null || node === void 0 ? void 0 : (_node$parentNode = node.parentNode) === null || _node$parentNode === void 0 ? void 0 : _node$parentNode.appendChild(hiddenSpan);
  forceHiddenStyles(hiddenSpan);
  return hiddenSpan;
};
export var getTextWidth = function getTextWidth(node) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  node.textContent = value;
  return node.offsetWidth;
};